import * as React from "react";
import { createReactBlockSpec } from "@blocknote/react";
import { AttachmentEditor } from "../AttachmentEditor";
import { Form } from "react-bootstrap";

export const TimerBlock = createReactBlockSpec(
  {
    type: "timer",
    content: "none",
    propSchema: {
      duration: {
        default: "00:10:00",
      },
    },
  },
  {
    render: (props) => {
      return (
        <AttachmentEditor type="Timer">
          <Form.Control
            type="time"
            step={2}
            value={props.block.props.duration}
            onChange={(e) =>
              props.editor.updateBlock(props.block.id, {
                props: { duration: e.target.value },
              })
            }
          />
        </AttachmentEditor>
      );
    },
  },
);
